import { render } from "./privacy.vue?vue&type=template&id=ae2828fe"
const script = {}

import "./privacy.vue?vue&type=style&index=0&id=ae2828fe&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__